import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './TournamentList.css';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import TournamentRow from './TournamentRow';
import { tournamentShape, tournamentsShape } from '../../utils/shapes';
import fragments from '../../utils/graphql/fragments';
import LoadingIndicator from '../../components/LoadingIndicator';
import {
  TOURNAMENT_STATUS_COMPLETED,
  TOURNAMENT_STATUS_IN_PROGRESS,
  TOURNAMENT_STATUS_UPCOMING
} from '../../utils/constants';
import { isMobile } from '../../utils/functions';
import orderBy from 'lodash/orderBy';
import { fromJS } from 'immutable';
import findIndex from 'lodash/findIndex';

import { Tab, Nav, NavItem } from 'react-bootstrap';
import withSounds from '../withSounds';
import '../HomePage/TabView/TabView.css';

const NavItemWithSounds = withSounds({ mouseEnterSound: true })(NavItem);

class TournamentList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: 1
    };

    this.unsubscribeFromNewData = () => {};
    this.handleSelect = this.handleSelect.bind(this);
  }

  componentDidMount() {
    this.unsubscribeFromNewData = this.props.subscribeToTournamentEvents();
  }

  componentWillUnmount() {
    this.unsubscribeFromNewData();
    this.unsubscribeFromNewData = () => {};
  }

  handleSelect(key) {
    this.setState({ activeTab: key });
  }

  render() {
    const { onInteraction, data, location } = this.props;

    if (data.loading || data.error) {
      return <LoadingIndicator expand />;
    }

    const { activeTab } = this.state;

    const inProgress =
      data.inProgress &&
      orderBy(data.inProgress.tournaments, ['startTime'], ['asc']);
    const upcoming =
      data.upcoming &&
      orderBy(data.upcoming.tournaments, ['startTime'], ['asc']);
    const completed =
      data.completed &&
      orderBy(data.completed.tournaments, ['endTime'], ['desc']);

    const isMobilePage = location ? isMobile(location.pathname) : false;

    const tabTitles = ['In Progress', 'Upcoming', 'Completed'];
    const renderNavItem = function(title, index) {
      let tab = index + 1;
      let Comp = tab === activeTab ? NavItem : NavItemWithSounds;
      return (
        <Comp key={tab} eventKey={tab}>
          {title}
        </Comp>
      );
    };

    return (
      <div
        className={`sub-tabs ${isMobilePage ? 'mobile-tournament-list' : ''}`}
      >
        <div className="tab-view">
          <Tab.Container
            id="uncontrolled-tab-view"
            className="tab-view-container"
            activeKey={activeTab}
            onSelect={this.handleSelect}
          >
            <div>
              <Nav bsStyle="tabs">{tabTitles.map(renderNavItem, this)}</Nav>
              <div className={`tab-indicator tab-${activeTab}`} />
              <Tab.Content animation mountOnEnter>
                <Tab.Pane eventKey={1}>
                  <TournamentRow
                    status={TOURNAMENT_STATUS_IN_PROGRESS}
                    tournaments={inProgress}
                    onInteraction={onInteraction}
                    isMobile={isMobilePage}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey={2}>
                  <TournamentRow
                    status={TOURNAMENT_STATUS_UPCOMING}
                    tournaments={upcoming}
                    onInteraction={onInteraction}
                    isMobile={isMobilePage}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey={3}>
                  <TournamentRow
                    status={TOURNAMENT_STATUS_COMPLETED}
                    tournaments={completed}
                    onInteraction={onInteraction}
                    isMobile={isMobilePage}
                  />
                </Tab.Pane>
              </Tab.Content>
            </div>
          </Tab.Container>
        </div>
      </div>
    );
  }
}

TournamentList.propTypes = {
  baseTournaments: PropTypes.array,
  onInteraction: PropTypes.func,
  data: PropTypes.shape({
    loading: PropTypes.bool,
    upcoming: tournamentsShape,
    inProgress: tournamentsShape,
    completed: tournamentShape
  }),
  isMobile: PropTypes.bool,
  subscribeToTournamentEvents: PropTypes.func.isRequired
};

const QUERY_GET_TOURNAMENTS = gql`
  query GetTournaments(
    $upcoming: GetTournaments!,
    $inProgress: GetTournaments!,
    $completed: GetTournaments!
  ) {
    upcoming: tournaments(tournaments: $upcoming) {
      tournaments { ...Tournament }
    }
    inProgress: tournaments(tournaments: $inProgress) {
      tournaments { ...Tournament }
    }
    completed: tournaments(tournaments: $completed) {
      tournaments { ...Tournament }
    }
  }
  ${fragments.tournament}
`;

export const SUBSCRIPTION_TOURNAMENT_EVENTS = gql`
  subscription TournamentUpdates {
    tournamentEvents {
      id
      event
    }
  }
`;

export default graphql(QUERY_GET_TOURNAMENTS, {
  options: {
    variables: {
      upcoming: { status: TOURNAMENT_STATUS_UPCOMING },
      inProgress: { status: TOURNAMENT_STATUS_IN_PROGRESS },
      completed: { status: TOURNAMENT_STATUS_COMPLETED }
    },
    fetchPolicy: 'cache-and-network'
  },
  props: ({ ownProps, data }) => {
    return {
      ...ownProps,
      data,
      subscribeToTournamentEvents: () => {
        return data.subscribeToMore({
          document: SUBSCRIPTION_TOURNAMENT_EVENTS,
          updateQuery: (
            prev,
            { subscriptionData: { data: { id, event } } }
          ) => {
            const eventTransitions = {
              start: { from: 'upcoming', to: 'inProgress' },
              end: { from: 'inProgress', to: 'completed' }
            };

            const transition = eventTransitions[event];

            if (
              transition &&
              findIndex(
                prev[transition.to].tournaments,
                element => element.id === id
              ) === -1
            ) {
              let fromTournaments = prev[transition.from].tournaments;

              const tournamentIdx = findIndex(
                fromTournaments,
                item => item.id === id
              );

              const oldTournament = fromJS(fromTournaments[tournamentIdx]);
              const newTournament = oldTournament.set(
                'status',
                oldTournament.get('status') === TOURNAMENT_STATUS_UPCOMING
                  ? TOURNAMENT_STATUS_IN_PROGRESS
                  : TOURNAMENT_STATUS_COMPLETED
              );

              return fromJS(prev)
                .updateIn([transition.to, 'tournaments'], arr =>
                  arr.push(newTournament)
                )
                .updateIn([transition.from, 'tournaments'], tournaments =>
                  tournaments.filter(tournament => tournament.get('id') !== id)
                )
                .toJS();
            }

            return prev;
          }
        });
      }
    };
  }
})(TournamentList);



// WEBPACK FOOTER //
// ./src/containers/TournamentList/index.js